module.exports = __webpack_public_path__ + "img/intro-text-image.0b81c5c6.png";